<div class="bg-white text-base h-full w-full rounded-lg text-gray-500 flex flex-col gap-4 justify-center items-center relative">

  @if (text === 'timeout') {
    <button id="closeTimeoutModal"
      class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl font-normal leading-none p-1 focus:outline-none cursor-pointer"
      (click)="closeOverlay(true)">
      ×
    </button>
  }

  <img src="/icons/exclamation.svg" class="h-9 w-9"/>

  @if (text === 'navigation') {

    <p class="text-center">{{getText().navigation}}</p>

  } @else if(text === 'cancel'){

    <p class="text-center">{{getText().cancel}}</p>

  }

  @else if(text === 'timeout'){
    <div class="flex flex-col justify-center items-center">
    <h1 class="text-l font-bold">Still There?</h1>
    <p id="timeout" class="text-center">{{ countdownText$ | async }}</p>
  </div>
  }
  

  <div class="flex gap-4">
    <!-- <button [class]="(text === 'navigation') ? 'bg-afcu-navy-800' : 'bg-red-700'" class="py-3 px-5  text-white rounded-xs font-semibold" (click)="closeOverlay(true)">{{getText().yes}}</button> -->
    <button [class]="(text === 'navigation' || text === 'timeout') ? 'bg-afcu-navy-800' : 'bg-red-700'" 
    class="py-3 px-5 text-white rounded-xs font-semibold" 
    (click)="closeOverlay(true)">
    {{ text=='timeout' ? getText().here : getText().yes }}
    </button>


    <button
    class="py-3 px-5 text-gray-800 border border-gray-200 rounded-xs font-semibold"
    (click)="text==='timeout' ? goodbyeAction() : closeOverlay(false)">
    {{ text=='timeout' ? getText().goodbye : getText().no }}
  </button>
  </div>
</div>